export default __webpack_public_path__ + "static/media/logo_agr.4a377a3b.png";